export default __webpack_public_path__ + "static/banner-61c8fdb89708dda26a0b3d658ca9b226.png";